import { ReactElement } from 'react'
import { Stack } from 'syf-component-library/ui/spacing'
import { H2, H4 } from 'syf-component-library/ui/typography'
import { Description, TextWrapper } from './subcomponents'
import { ContentWrapper, ImageWrapper } from '../subcomponents'

interface AddAccountResponseProps {
  image: string
  title: string
  description: string
  isDesktop: boolean
}

const AddAccountResponseScreen = ({
  image,
  title,
  description,
  isDesktop
}: AddAccountResponseProps): ReactElement => {
  return (
    <ContentWrapper data-test={title}>
      <ImageWrapper>
        <img
          src={image}
          alt={`${title} Banner`}
          data-cy="add-account-response-image"
        />
      </ImageWrapper>
      <Stack size="large" />
      <TextWrapper data-cy="add-account-response-title">
        {isDesktop ? (
          <H2 weight="bold">{title}</H2>
        ) : (
          <H4 weight="bold">{title}</H4>
        )}
      </TextWrapper>
      <Stack size="xsmall" />
      <Description data-cy="add-account-response-description">
        {description}
      </Description>
    </ContentWrapper>
  )
}

export default AddAccountResponseScreen
